import { CssVarsThemeOptions } from '@mui/material';

export const primaryFont = "'Open-Sans', sans-serif";
export const secondaryFont = "'Overpass', sans-serif";

const pxToRem = (value: number) => {
  return `${value / 16}rem`;
};

const responsiveFontSizes = ({
  sm,
  md,
  lg,
}: {
  sm: number;
  md: number;
  lg: number;
}) => {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:960px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1280px)': {
      fontSize: pxToRem(lg),
    },
  };
};

export const typography: CssVarsThemeOptions['typography'] = {
  fontFamily: primaryFont,
  fontFamilyAlt: secondaryFont,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontFamily: secondaryFont,
    fontWeight: 700,
    lineHeight: 1.15,
    fontSize: pxToRem(40),
    ...responsiveFontSizes({ sm: 48, md: 54, lg: 58 }),
  },
  h2: {
    fontFamily: secondaryFont,
    fontWeight: 700,
    lineHeight: 1.15,
    fontSize: pxToRem(32),
    fontStyle: 'italic',
    ...responsiveFontSizes({ sm: 38, md: 42, lg: 44 }),
  },
  h3: {
    fontFamily: secondaryFont,
    fontWeight: 700,
    lineHeight: 1.15,
    fontSize: pxToRem(24),
    ...responsiveFontSizes({ sm: 24, md: 28, lg: 30 }),
  },
  h4: {
    fontFamily: secondaryFont,
    fontWeight: 700,
    lineHeight: 1.15,
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
  },
  h5: {
    fontFamily: secondaryFont,
    fontWeight: 700,
    lineHeight: 1.15,
    fontSize: pxToRem(18),
    fontStyle: 'italic',
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
  },
  h6: {
    fontFamily: secondaryFont,
    fontWeight: 500,
    lineHeight: 1.15,
    fontSize: pxToRem(17),
    fontStyle: 'italic',
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
  },
  subtitle1: {
    lineHeight: 1.5,
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  body1: {
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  body2: {
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(12),
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 700,
    lineHeight: 24 / 14,
    fontSize: pxToRem(14),
    textTransform: 'uppercase',
  },
};
